module.exports = __webpack_public_path__ + "static/media/Seb_Wagner.d2e3a3d9.jpeg";